import { render, staticRenderFns } from "./deleteScheduleClassesStaff.vue?vue&type=template&id=e794a5fc&scoped=true"
import script from "./deleteScheduleClassesStaff.vue?vue&type=script&lang=js"
export * from "./deleteScheduleClassesStaff.vue?vue&type=script&lang=js"
import style0 from "./deleteScheduleClassesStaff.vue?vue&type=style&index=0&id=e794a5fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e794a5fc",
  null
  
)

export default component.exports